<template>
  <div>
    <div class="tips">欢迎来到用户体验全生命周期管理平台</div>
    <div class="container">
      <el-card>
        <div id="line_day" style="width: 100%; height: 400px"></div>
      </el-card>
      <br>
      <el-card>
        <div id="line_month" style="width: 100%; height: 400px"></div>
      </el-card>
    </div>
  </div>

</template>

<script>
  import * as echarts from 'echarts';

	export default {
		name: "Index",
    data() {
		  return {
		    dateDayStr: [],
        dataDaySeries: [],
        dateMonthStr: [],
        dataMonthSeries: [],
      }
    },
    created() {
		  this.getUserCountDay()
      this.getUserCountMonth()
    },
    methods: {
      getUserCountDay() {
        this.$axios.post("/uxm/user/userCount", {}).then(res => {
          let dataJson = []
          let countJson = []
          res.data.data.forEach(item => {
            dataJson.push(item['dateStr'])
            countJson.push(item['userCount'])
          });
          this.dateDayStr = dataJson
          this.dataDaySeries = countJson
          this.initEchartDay()
        });
      },
      getUserCountMonth() {
        this.$axios.post("/uxm/user/userCount", {
          month: 'month'
        }).then(res => {
          let dataJson = []
          let countJson = []
          res.data.data.forEach(item => {
            dataJson.push(item['dateStr'])
            countJson.push(item['userCount'])
          });
          this.dateMonthStr = dataJson
          this.dataMonthSeries = countJson
          this.initEchartMonth()
        });
      },
      initEchartDay() {
        let lineBox = echarts.init(document.getElementById('line_day'))
        let option;
        option = {
          title: {
            text: '用户每日增长（天/人数）'
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: this.dateDayStr
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: this.dataDaySeries,
              type: 'line'
            }
          ]
        };
        option && lineBox.setOption(option);
      },
      initEchartMonth() {
        let lineBox = echarts.init(document.getElementById('line_month'))
        let option;
        option = {
          title: {
            text: '用户每月增长（月/人数）'
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: this.dateMonthStr
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: this.dataMonthSeries,
              type: 'line'
            }
          ]
        };
        option && lineBox.setOption(option);
      }
    }
  }
</script>

<style scoped>
  .tips {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }

  .container {
    width: 100%;
    margin-top: 20px;
  }

</style>
